import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import {
  cookingstorySuggest,
  cookingStoryPageCategories,
  CookingStoryPageResponce,
} from 'src/app/core/model/api-response/cooking-story-model';
import { IndexdbLastupdateService } from '../indexdb-lastupdate/indexdb-lastupdate.service';

@Injectable({
  providedIn: 'root',
})
export class CookingStoryDataService {
  constructor(
    private dbService: NgxIndexedDBService,
    private IndexdbLastupdateService: IndexdbLastupdateService
  ) {}
  async getCookingStoryData(id: string) {
    const cateGorie = this.getCategorie(id);
    const isUpdate = this.IndexdbLastupdateService.chekForUpdate(
      'cookingStoryUpdatedAt'
    );
    if (cateGorie) {
      if (isUpdate) {
        this.dbService.clear('cookingbook');
        this.IndexdbLastupdateService.updateCookingStory(
          this.IndexdbLastupdateService.getNextDayTime()
        );
        return true;
      } else {
        return cateGorie;
      }
    } else {
      return true;
    }
  }
  async getCategorie(id: string): Promise<boolean | CookingStoryPageResponce> {
    const fls = await this.dbService.getByIndex('cookingbook', '_id', id);
    if (fls) {
      return new CookingStoryPageResponce(
        200,
        0,
        fls['suggestion'],
        fls['categories']
      );
    } else {
      return false;
    }
  }
  async saveCategorie(
    id: string,
    suggestion: cookingstorySuggest,
    categories: cookingStoryPageCategories[]
  ): Promise<boolean> {
    const fls = await this.dbService.getByIndex('cookingbook', '_id', id);
    let response = true;
    if (fls) {
      response = true;
    } else {
      response = await this.dbService
        .add('cookingbook', {
          _id: id,
          suggestion: suggestion,
          categories: categories,
        })
        .then(
          () => {
            return true;
          },
          (error) => {
            return false;
          }
        );
    }
    return Promise.resolve(response);
  }
}
